import { render, staticRenderFns } from "./CollectionWronglistFilter.vue?vue&type=template&id=674b4086&scoped=true&"
import script from "./CollectionWronglistFilter.vue?vue&type=script&lang=js&"
export * from "./CollectionWronglistFilter.vue?vue&type=script&lang=js&"
import style0 from "./CollectionWronglistFilter.vue?vue&type=style&index=0&id=674b4086&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674b4086",
  null
  
)

export default component.exports